import classNames from "classnames";
import { useEffect, useMemo, useState } from "react";

import { Icon } from "src/app/components/icon/Icon";

import pageCSS from "./Pagination.module.css";

const Pagination = ({ currentPage = 1, recordsPerPage = 5, numberOfPages = 0, onPageChange = (pageNum: number) => {} }) => {
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    if (numberOfPages > 0 && recordsPerPage > 0) {
      setTotalPages(numberOfPages);
    }
  }, [numberOfPages, recordsPerPage]);

  const pageItems = useMemo(() => {
    const pages: any = [];
    const numOfPagesToShowOnStart: number = 3;
    const numOfPagesToShowOnEnd: number = 3;
    const numOfPagesToShowBeforeAndAfterCurrentPage: number = 2;
    let addDots: boolean = true;

    for (let index = 1; index <= totalPages; index++) {
      if (
        index <= numOfPagesToShowOnStart ||
        index > totalPages - numOfPagesToShowOnEnd ||
        (index >= currentPage - numOfPagesToShowBeforeAndAfterCurrentPage && index <= currentPage + numOfPagesToShowBeforeAndAfterCurrentPage)
      ) {
        pages.push(<Page key={index} pageNumber={index} currentPage={currentPage} onPageChange={(index: number) => onPageChange(index)} />);
        addDots = true;
      } else {
        if (addDots) {
          pages.push(<div>...</div>);
        }
        addDots = false;
      }
    }

    return pages;
  }, [totalPages, currentPage, onPageChange]);

  if (numberOfPages === 0) return null;

  return (
    <div className={classNames("u-flex", "u-flex-content-center", "u-w100", pageCSS.container)}>
      {numberOfPages > 0 && (
        <div className="u-flex u-w40">
          <ul className={classNames("u-flex", "u-w100", "u-flex-content-center", "u-flex-items-center", pageCSS.list)}>
            <li
              key="0"
              className={currentPage === 1 ? "disabled" : "u-cursor-pointer"}
              onClick={() => (currentPage === 1 ? undefined : onPageChange(currentPage - 1))}
            >
              <Icon
                name="arrow-left"
                className={classNames(
                  "u-t-nodecoration",
                  "u-t-valign-basemid",
                  "u-t-f16p",
                  "u-t-w700",
                  "u-t-lh15",
                  currentPage === 1 ? pageCSS.arrowDisabled : pageCSS.arrowActive
                )}
              />
            </li>
            {pageItems}
            <li
              key={numberOfPages + 1}
              className={currentPage === numberOfPages ? "disabled" : "u-cursor-pointer"}
              onClick={() => (currentPage === numberOfPages ? undefined : onPageChange(currentPage + 1))}
            >
              <Icon
                name="arrow-right"
                className={classNames(
                  "u-t-nodecoration",
                  "u-t-valign-basemid",
                  "u-t-f16p",
                  "u-t-w700",
                  "u-t-lh15",
                  currentPage === numberOfPages ? pageCSS.arrowDisabled : pageCSS.arrowActive
                )}
              />
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Pagination;

const Page = ({ pageNumber = 1, currentPage = 1, onPageChange = (pageNum: number) => {} }) => {
  return (
    <li
      key={pageNumber}
      className={classNames(
        "u-t-nodecoration",
        "u-t-f16p",
        "u-t-w400",
        "u-t-lh15",
        currentPage === pageNumber ? "u-t-primary u-t-w700 " : "u-t-secondary u-cursor-pointer"
      )}
      onClick={() => (pageNumber !== currentPage ? onPageChange(pageNumber) : {})}
    >
      <span className="u-t-valign-ttop">{pageNumber}</span>
    </li>
  );
};
